import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAssetRepeatAppIconOl = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 39,
		height: 39,
		rx: 12.5,
		fill: "#091F24",
		stroke: "#091F24"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M26.0382 27.1404L29.8867 30.9996H19.4582V20.545L23.3315 24.427L24.7984 22.956C27.3353 20.0969 27.9424 18.2458 27.0259 16.1325C26.1596 14.1356 24.1246 12.8427 21.839 12.8427H13.8331V31H10V9H21.8394C25.6577 9 29.0688 11.2019 30.5439 14.606C32.7806 19.7722 29.1657 23.8253 27.626 25.5563L26.0382 27.1404Z",
		fill: "white"
	})]
});
export default SvgAssetRepeatAppIconOl;
